/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./FormVueSelect.vue?vue&type=template&id=4b860cd6&scoped=true"
import script from "./FormVueSelect.vue?vue&type=script&lang=js"
export * from "./FormVueSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b860cd6",
  null
  
)

export default component.exports